<template>
  <div class="resend-container">
    <div v-if="error">{{ error }}</div>
    <div v-else-if="verified">{{ $t('email.verified') }}</div>
    <div v-else-if="sent" v-html="$t('verification.email.sent', { email })"></div>
    <div v-else v-html="$t('sending.verification.email', { email })"></div>
  </div>
</template>

<script>
import firebase from 'firebase/app';
import { mapActions } from 'vuex';
import { SEND_VERIFICATION_EMAIL } from '@/store/session/actionTypes';

export default {
  data() {
    return {
      error: '',
      verified: false,
      sent: false,
    };
  },
  computed: {
    user() {
      return firebase.auth().currentUser;
    },
    email() {
      return this.user?.email;
    },
  },
  methods: {
    ...mapActions({
      sendVerificationEmail: SEND_VERIFICATION_EMAIL,
    }),
    async resendVerificationEmailIfNeeded() {
      try {
        await this.sendVerificationEmail({ silently: true });
        this.sent = true;
      } catch (error) {
        this.error = this.$t('error');
      }
    },
  },
  created() {
    if (this.user) {
      this.verified = this.user.emailVerified;
      this.resendVerificationEmailIfNeeded();
    } else {
      this.error = this.$t('unauthorized.action');
    }
  },
};
</script>

<style lang="scss" scoped>
.resend-container {
  text-align: center;
}
</style>
